import { createEntityAdapter } from '@reduxjs/toolkit';

import { State } from 'Libs/redux/reducer';
import { ActivityDashboardItem } from './activity.type';

export const activityAdapter = createEntityAdapter<ActivityDashboardItem>({});

export const { selectAll, selectById, selectTotal } = activityAdapter.getSelectors();

export const selectActivityEditionError = (state: State) => state.entities.activity.edition.error;
export const selectActivityEditionSuccess = (state: State) => state.entities.activity.edition.success;

export const selectCampaignMagicCode = (state: State) =>
  state.entities.activity.edition.campaign?.audiences?.[0]?.segments?.[0]?.magicCodes?.[0];

export const selectBreakingNewsMagicCode = (state: State) =>
  state.entities.activity.edition.breakingNews?.audiences?.[0]?.segments?.[0]?.magicCodes?.[0];
